import moment from "moment";

export const DATE_RANGE_PRESETS = [
  { labelKey: "meetings.date_range_all_time", getValue: () => ({ from: null, to: null }) },
  { labelKey: "meetings.date_range_last_7_days", getValue: () => ({ from: moment().subtract(7, "days").toDate(), to: new Date() }) },
  { labelKey: "meetings.date_range_last_30_days", getValue: () => ({ from: moment().subtract(30, "days").toDate(), to: new Date() }) },
  { labelKey: "meetings.date_range_last_month", getValue: () => ({ from: moment().subtract(1, "month").startOf("month").toDate(), to: moment().subtract(1, "month").endOf("month").toDate() }) },
  { labelKey: "meetings.date_range_last_3_months", getValue: () => ({ from: moment().subtract(3, "months").startOf("month").toDate(), to: new Date() }) },
  { labelKey: "meetings.date_range_last_6_months", getValue: () => ({ from: moment().subtract(6, "months").startOf("month").toDate(), to: new Date() }) },
  { labelKey: "meetings.date_range_this_year", getValue: () => ({ from: moment().startOf("year").toDate(), to: new Date() }) },
  { labelKey: "meetings.date_range_last_year", getValue: () => ({ from: moment().subtract(1, "year").startOf("year").toDate(), to: moment().subtract(1, "year").endOf("year").toDate() }) },
];

export const UPCOMING_DATE_PRESETS = [
  { labelKey: "meetings.jump_to_date_all_upcoming", getValue: () => ({ from: null, to: null }) },
  { labelKey: "meetings.today", getValue: () => ({ from: moment().startOf("day").toDate(), to: moment().endOf("day").toDate() }) },
  { labelKey: "meetings.tomorrow", getValue: () => ({ from: moment().add(1, "day").startOf("day").toDate(), to: moment().add(1, "day").endOf("day").toDate() }) },
  { labelKey: "meetings.jump_to_date_this_week", getValue: () => ({ from: moment().startOf("isoWeek").toDate(), to: moment().endOf("isoWeek").toDate() }) },
  { labelKey: "meetings.jump_to_date_next_week", getValue: () => ({ from: moment().add(1, "week").startOf("isoWeek").toDate(), to: moment().add(1, "week").endOf("isoWeek").toDate() }) },
  { labelKey: "meetings.jump_to_date_next_30_days", getValue: () => ({ from: moment().startOf("day").toDate(), to: moment().add(30, "days").endOf("day").toDate() }) },
];

export const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDateTimeWithTimeZone(dateValue) {
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formattedDate = new Intl.DateTimeFormat(undefined, options).format(date);

  const timeZoneName = new Intl.DateTimeFormat(undefined, {
    ...options,
    timeZoneName: "long",
  })
    .formatToParts(date)
    .find((part) => part.type === "timeZoneName")?.value;

  return timeZoneName ? `${formattedDate} (${timeZoneName})` : formattedDate;
}
